import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { KpiService } from "../kpi/kpi.service";
import * as _ from "lodash";

@Component({
  selector: "app-dashboard-config-settings",
  templateUrl: "./dashboard-config-settings.component.html",
  styleUrls: ["./dashboard-config-settings.component.scss"],
})
export class DashboardConfigSettingsComponent implements OnInit {
  dashboardSettingsNavItemData = [
    {
      title: "schools",
      route: "/data-configuration/settings/schools",
      icon: "school_configs",
    },
    {
      title: "demographics",
      route: "/data-configuration/settings/demographic",
      icon: "demographic_breakdowns",
    },
  ];
  constructor(
    private kpiService: KpiService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    _.map(this.dashboardSettingsNavItemData, (item: any) => {
      if (
        (this.router.url == "/data-configuration/settings/" ||
          this.router.url == "/data-configuration/settings") &&
        item["title"] == "demographics"
      ) {
        item.selected = true;
      } else {
        item.selected = this.router.url.includes(item["route"]);
      }
    });
  }

  ngOnInit() {
    this.kpiService.getUserInfo().subscribe(
      (data) => {
        this.kpiService.title = data.customer_name;
        if (data.sz_tier !== "starter") {
          this.dashboardSettingsNavItemData = [
            ...this.dashboardSettingsNavItemData,
            {
              title: "metrics",
              route: "/data-configuration/settings/configuration",
              icon: "metric_config",
            },
          ];
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  navItemClicked(item) {
    _.map(this.dashboardSettingsNavItemData, (navItem: any) => {
      navItem.selected = navItem["title"] === item["title"];
    });
    this.router.navigate([item.route]);
  }
}
